import templateUrl from "./news-main.html";

export const newsMainComponent = {
  templateUrl,
  bindings: {
    tags: "<",
    type: "@",
    title: "@",
    details: "<",
    categories: "<",
  },

  controller: class NewsMainComponent {
    constructor(
      $state,
      toastr,
      ApiService,
      NewsService,
      NewsTagService,
      NewsCategoryService
    ) {
      "ngInject";

      this.$state = $state;
      this.toastr = toastr;
      this.imageUrl = null;
      this.ApiService = ApiService;
      this.NewsService = NewsService;
      this.disableButttonSubmit = false;
      this.NewsTagService = NewsTagService;
      this.NewsCategoryService = NewsCategoryService;
    }
    $onInit() {
      this.tags = this.modifyList("tag", this.tags);
      this.categories = this.modifyList("category", this.categories);
      if (this.details) {
        this.details.newsTagList = this.modifyList(
          "tag",
          this.details.newsTagList
        );
        this.details.newsCategoryList = this.modifyList(
          "category",
          this.details.newsCategoryList
        );
      }

      if (this.details && this.details.fileUuid) {
        this.imageUrl = this.ApiService.getImageUrl(this.details.fileUuid);
      }
      this.details = this.details || {};
      this.datePickerSelectedDate = this.details.publishDate
        ? { selectedDate: this.details.publishDate }
        : { selectedDate: new Date() };
    }
    modifyList(type, list) {
      if (type === "tag") {
        return list.map(({ newsTagId: id, name }) => ({ id, name }));
      } else {
        return list.map(({ newsCategoryId: id, name }) => ({ id, name }));
      }
    }
    onDateChange(date) {
      this.details.publishDate = date.selectedDate;
    }
    onImageUpload({ details: { uuid } }) {
      this.imageUrl = this.ApiService.getImageUrl(uuid);
      this.details.fileUuid = uuid;
    }
    onRemoveImage() {
      this.imageUrl = null;
      this.details.fileUuid = null;
    }
    onTagDropdownChange(type, data) {
      if (type === "tag") {
        this.details.newsTagList = data;
      } else {
        this.details.newsCategoryList = data;
      }
    }

    modifySubmitDetails(data) {
      const details = {
        link: data.link,
        title: data.title,
        newsId: data.newsId,
        fileId: data.fileId,
        summary: data.summary,
        fileUuid: data.fileUuid,
        createdAt: data.createdAt,
        publishDate: data.publishDate,
      };
      if (data.newsTagList && data.newsTagList.length > 0) {
        details.newsTagIds = data.newsTagList.map(({ id }) => id);
      }
      if (data.newsCategoryList && data.newsCategoryList.length > 0) {
        details.newsCategoryIds = data.newsCategoryList.map(({ id }) => id);
      }

      if (data.publishDate) {
        details.publishDate = data.publishDate;
      } else {
        details.publishDate = this.datePickerSelectedDate.selectedDate;
      }
      return details;
    }

    onSubmit() {
      const modifiedObj = this.modifySubmitDetails(this.details);
      if (modifiedObj) {
        this.NewsService.updateNews(modifiedObj, this.type)
          .then((_) => {
            this.toastr.success("News Updated Successfully.");
            this.$state.go("news");
          })
          .catch((error) => {
            this.toastr.error(error.data.errors.message);
          });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/news/news-main/news-main.component.js